import $ from 'jquery';
import listService from 'ListService';
import constants from 'Constants.js';
import _ from 'lodash';
import util from 'util/Util.js';

import { View } from 'backbone';

import _Template from 'properties/accessibility/hidden.ejs';

class NavHiddenView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = '#accessibilityHidden';

        if (this.model.get('isHidden')=== null || this.model.get('isHidden') === undefined ) {
            this.model.set('isHidden',false, {silent: true});
        }


        this.events = {
            'change input[type=checkbox]' : 'updateCheckboxAttributes'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }
    /*=====================================================================================================
      Method that updates the ZOrder if the control depending if the control is set to hidden.
      If it is,it will get the lowest zOrder defined for all the controls and 
      if not it will back to the original one that had before it was hidden.
      ======================================================================================================= */
    updateZOrder(isHidden){
        if(isHidden){
            this.model.set('zOrder', constants.HIDDEN_Z_ORDER);
        }
        else{
            this.model.set('zOrder', this.model.get('originalZOrder'));
        }
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const isHidden  = ev.currentTarget.checked;
        const propName = ev.currentTarget.name;

        this.updateZOrder(isHidden);

        if (propName === 'isHiddenTablet') {
            this.model.get('deviceTablet').isHidden = isHidden;
        }
        if (propName === 'isHiddenPhone') {
            this.model.get('devicePhone').isHidden = isHidden;
        }
        this.model.trigger('change');
        
    }

    render() {
        this.$el.empty();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        /*
            PF-2605. Hide this property for now. This should be reactivated later on during the process-
            Please DON'T REMOVE THIS.
        */

        /*const currentFormModel = _.get(listService, 'currentForm.model');
        if(!(currentFormModel && util.isTrue(currentFormModel.get('responsive')))) {
            $('#isHiddenPhone').prop('readonly', 'readonly');
            $('#isHiddenPhone').prop('disabled', 'disabled');
            $('#isHiddenTablet').prop('readonly', 'readonly');
            $('#isHiddenTablet').prop('disabled', 'disabled');
        } else {
            if (this.model.get('isMandatory')) {
                // uncheck and disable
                $('#isHiddenPhone').prop('checked', false);
                $('#isHiddenPhone').prop('disabled', 'disabled');
                $('#isHiddenTablet').prop('checked', false);
                $('#isHiddenTablet').prop('disabled', 'disabled');
            } else {
                $('#isHiddenPhone').prop('disabled', '');
                $('#isHiddenTablet').prop('disabled', '');
            }
        }

        this.delegateEvents();*/
        return this;
    }

}

export default NavHiddenView;
